import styled from 'styled-components'

import { size_4, media } from '../../../module/style-variables'

export const HeaderContainer = styled.div`
  text-align: center;
  padding: ${size_4} ${size_4} 0 ${size_4};

  .HeaderLogo {
    width: 60px;
    ${media.screen_lg`
      width: 100px;
    `};
  }
`



// WEBPACK FOOTER //
// ./src/component/_presentational/Header/Header-styled.js